<template>
  <page-view>
    <a-row :gutter="16">
      <a-col :span="8">
        <a-card :bordered="false">
          <div class="index_t1">
            <div class="r2">
              <div class="img">
                <expert-upload-view avatar-flag
                                    config-key="expert.apply.peoplePicture"
                                    :refer-id="expertInfoData.id"/>
              </div>
              <div class="info">
                <p class="text1">
                  {{ user.name }} <small style="color: #6b6b6b;margin-left: 10px;font-size: 16px">
                  <a-icon type="idcard"/>
                  {{ expertInfoData.idCard }}</small>
                  <span class="ml-5"
                        v-if="expertInfoData.id">
                    <a-tag color="red"
                           v-if="leaveOrNot(expertInfoData)">
                      休假中
                    </a-tag>
                    <a-tag color="red"
                           v-if="expertInfoData.state==expertState.STATE.OUT_DOING">
                      出库中
                    </a-tag>
                  </span>
                  <a-tag v-else
                         class="ml-5"
                         color="red">已出库
                  </a-tag>
                </p>
                <div class="text2">
                  <div>手机号：{{ expertInfoData.mobilePhone }} <a @click="editPhone(expertInfoData)">【更换】</a></div>
                  <div style="width: 100%">联系地址：{{ expertInfoData.address }}</div>
                  <div style="width: 100%">
                    工作单位：{{ expertInfoData.isIncumbency == '1' ? expertInfoData.unitName : '退休' }}
                  </div>

                </div>
              </div>
            </div>
            <div class="r3">
              今天是您加入的第<b>{{ expertInfoData.addDate | fromNow }}</b>天，感谢您一直以来的支持配合与辛勤付出！
            </div>
          </div>
          <img class="card_img"
               src="../../assets/p1.png">
        </a-card>

        <a-card class="index_t2">
          <div class="item">
            <img class="img"
                 src="../../assets/p5.png">
            <div>
              <p class="text1">我司自动语音通知电话号码：<b>{{ calledShowNumber | calledNumberFormat }}</b></p>
              <p class="text2">请存储此号码并及时接听，勿视为广告骚扰电话</p>
            </div>
          </div>
          <div class="item v2">
            <img class="img" :src="qrcode" style="width: 86px;margin: 8px 17px 8px 5px"/>
            <p class="text3" style="margin-bottom: 0;font-size: 16px">
              请关注我司微信服务号，可通过服务号下部“专家服务”功能随时查看采购活动通知，并可以操作请假，进行休假设置。
            </p>
<!--            <a-icon type="right-circle"-->
<!--                    theme="filled"/>-->
          </div>
        </a-card>
      </a-col>
      <a-col :span="16">
        <a-card title="最新采购活动通知"
                class="card_right_first"
                :bordered="false"
                :loading="loading.reviewActiveNotice">
          <span slot="extra"
                style="color:red;cursor: pointer;"
                @click="openLeaveDescription">
            <a-icon type="question-circle"
                    class="mr-1"/>请假说明
          </span>
          <ul class="cghd_list"
              v-if="reviewActiveNotice.length>0">
            <li v-for="item in reviewActiveNotice" style="position:relative"
                :key="item.id">
              <a-row class="info">
                <a-col :span="7"
                       class="text1"><span class="title">集合时间：</span>
                  <span style="color: blue">{{ item.setOfTime }}</span></a-col>
                <a-col :span="17"
                       class="text1"><span class="title">集合地点：</span><span
                    style="color: blue">{{ item.setOfAddress }}</span></a-col>
                <a-col :span="7"
                       class="text1"><span class="title">活动类型：</span><span style="color: blue"> <dict-text
                    dictKey="BID_ZJSZYT"
                    :value="item.applyType"
                    style="width: 100%"/></span></a-col>
                <a-col :span="7"
                       class="text1"><span class="title">预计时长：</span><span
                    style="color: blue">{{ item.reviewDuration }}</span></a-col>
                <a-col :span="17"
                       class="text1"><span class="title">需携带资料：</span><span
                    style="color: blue">{{ item.information }}</span></a-col>
              </a-row>
              <a-row type="flex"
                     justify="space-between"
                     class="mt-2">
                <a-col :span="12"
                       style="padding-left: 16px;font-size:16px;">
                  通知日期：{{ item.addDate | dayjs('YYYY-MM-DD') }}
                </a-col>
                <a-col :span="12">
                  <div class="btn_box">
                    <div v-if="extractExpertFlagEnum.ATTEND[0]===item.expertFlag">
                      <button @click="onLeaveApplyFor(item)"
                              :disabled="loading.attend">
                        <a-icon type="clock-circle"
                                theme="filled"
                                style="color:#FF9A9A "/>
                        请假
                      </button>
                    </div>
                    <!--                    <div v-if="extractExpertFlagEnum.EXTRACT[0]==item.expertFlag">-->
                    <!--                      <button @click="onNotAgreeJoin(item)">-->
                    <!--                        <a-icon type="close-circle"-->
                    <!--                                theme="filled"-->
                    <!--                                style="color:#FF9A9A " />-->
                    <!--                        不参加</button>-->
                    <!--                      <button @click="onAgreeJoin(item)">-->
                    <!--                        <a-icon type="check-circle"-->
                    <!--                                theme="filled"-->
                    <!--                                style="color:#15B866 " />-->
                    <!--                        同意参加</button>-->
                    <!--                    </div>-->
                  </div>
                </a-col>
              </a-row>
              <div style="position: absolute;right: 29px;top: 13px;z-index: 99;">
                <img v-if="extractExpertFlagEnum.ATTEND[0]===item.expertFlag" style="width: 90px"
                     :src="$_c + 'img/attend.png'">
                <img v-if="extractExpertFlagEnum.BUSY[0]===item.expertFlag" style="width: 90px"
                     :src="$_c + 'img/noAttend.png'">
                <img v-if="extractExpertFlagEnum.LEAVE[0]===item.expertFlag" style="width: 90px"
                     :src="$_c + 'img/leave.png'">
              </div>
            </li>
          </ul>
          <div v-else
               class="flex-center">
            <a-empty description="暂无新通知">
              <!--  <a-button type="primary"
                      @click="goToPreviewHistory">
              查看历史采购活动通知
            </a-button> -->
            </a-empty>
          </div>
        </a-card>
        <a-card class="card_right_two"
                title="审批记录">
          <table class="fx-form-view"
                 style="text-align: center"
                 v-if="auditRecordList.length!=0">
            <tr>
              <th>申请时间</th>
              <th>申请类型</th>
              <th>审核时间</th>
              <th>审核状态</th>
              <th>操作</th>
            </tr>
            <tr v-for="auditRecord in auditRecordList"
                :key="auditRecord.id">
              <td>{{ auditRecord.applyForDate | dateFormat }}</td>
              <td>申请修改品目</td>
              <td><span v-if="auditRecord.auditDate">{{ auditRecord.auditDate | dateFormat }}</span></td>
              <td>
                <a-tag :color="expertAuditRecordStatusEnum.getValOrCol(auditRecord.auditStatus).color">
                  {{ expertAuditRecordStatusEnum.getValOrCol(auditRecord.auditStatus).value }}
                </a-tag>
              </td>
              <td>
                <a-button type="link"
                          @click="onViewAuditRecord(auditRecord)">查看
                </a-button>
              </td>
            </tr>
          </table>
          <div v-else
               class="flex-center">
            <a-empty></a-empty>
          </div>
        </a-card>
      </a-col>
    </a-row>


    <edit-mobile-phone-modal ref="editMobilePhone"
                             @success="getExpertInfo()"/>
    <edit-bank-modal ref="editBank"
                     :expertInfo="expertInfoData"
                     @success="getExpertInfo()"/>
    <expert-leave-apply-for-modal ref="expertLeaveApplyForModal"
                                  @leaveSuccess="onLoadReviewActiveNotice()"/>
    <EditExpertPurchaseItem ref="editExpertPurchaseItem"
                            @success="getAuditRecord(expertInfoData.id)"
                            @revocation="getAuditRecord(expertInfoData.id)"/>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'
import { GetExpertByUserId, GetEditPurchaseItemList } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import {
  QueryExpertReviewActiveNoticeListByUserIdList,
  SetParticipationStatus
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import NotAttendReason from '@/epp/expertmain/selectexpertapply/modal/NotAttendReason.vue'
import EditMobilePhoneModal from './EditMobilePhoneModal'
import EditBankModal from './EditBankModal'
import ExpertLeaveApplyForModal from '@/epp/expertmain/expertInfo/common/ExpertLeaveApplyForModal'
import DictText from '@/components/dict/DictText'
import {
  ExpertState,
  IsLeaveRecord,
  ExpertAuditRecordStatusEnum
} from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { QueryMetadataList } from '@/api/componentsApi'
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'
import EditExpertPurchaseItem from '@/epp/expertmain/expertInfo/common/edititem/EditExpertPurchaseItem.vue'
import { CONSULT_TELE_PHONE, COMPANY_WEBSITE } from '@/store/mutation-types'
import { GetContentResourceByKey } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { ACTION_TYPE, EXPERT_QR_CODE } from '@/epp/sysContentMange/util/sysContentMangeUtil'

export default {
  name: 'Workplace',
  inject: ['reload'],
  components: {
    PageView,
    NotAttendReason,
    EditMobilePhoneModal,
    EditBankModal,
    ExpertLeaveApplyForModal,
    DictText,
    ExpertUploadView,
    EditExpertPurchaseItem
  },
  async created () {
    await this.getExpertInfo()
    this.onLoadReviewActiveNotice()
    this.getCalledShowNumber()
    this.getQrCode()
  },
  computed: {
    // 判断是否在休假
    leaveOrNot () {
      return function (expertInfo) {
        const notExtractStartTime = expertInfo.notExtractStartTime
        const notExtractEndTime = expertInfo.notExtractEndTime
        return IsLeaveRecord(notExtractStartTime, notExtractEndTime)
      }
    }
  },
  data () {
    return {
      expertState: ExpertState,
      expertAuditRecordStatusEnum: ExpertAuditRecordStatusEnum,
      user: this.$ls.get('user'),
      consult_telePhone: this.$ls.get(CONSULT_TELE_PHONE),
      website: this.$ls.get(COMPANY_WEBSITE),
      expertInfoData: { extras: {} },
      calledShowNumber: '',
      loading: {
        reviewActiveNotice: true,
        attend: false
      },
      allMarkPoints: [],
      markPoints: [],
      reviewActiveNotice: [],
      extractExpertFlagEnum: ExtractExpertFlagEnum,
      leaveApplyForVisible: false,
      auditRecordList: [],
      qrcode: ''
    }
  },
  methods: {
    async getQrCode () {
      //获取二维码
      this.qrcode = await GetContentResourceByKey(EXPERT_QR_CODE, ACTION_TYPE.system)
    },
    async getExpertInfo () {
      const res = await GetExpertByUserId()
      const result = res.result
      if (res.code == 200 && result) {
        this.expertInfoData = result
        this.getAuditRecord(result.id)
      }
    },
    async onLoadReviewActiveNotice () {
      const that = this
      try {
        that.loading.reviewActiveNotice = true
        const data = { pageSize: 6 }
        let res = await QueryExpertReviewActiveNoticeListByUserIdList(data)
        that.reviewActiveNotice = res.result
      } catch (e) {
        this.$message.error(e.message)
        that.loading.reviewActiveNotice = false
      } finally {
        that.loading.reviewActiveNotice = false
      }
    },
    async getCalledShowNumber () {
      const metadata = await QueryMetadataList('ivrCall', 'calledShowNumber')
      if (metadata.code == 200) {
        this.calledShowNumber = metadata.result[0].value
      }
    },
    /**
     * 获取审批记录
     */
    async getAuditRecord (expertId) {
      let auditRecordList = []
      const res = await GetEditPurchaseItemList(expertId)
      if (res.code == 200) {
        auditRecordList = res.result
      }
      this.auditRecordList = auditRecordList
    },
    /**
     * 前往修改银行信息
     */
    editBank (expertInfoData, isUpdate) {
      this.$refs.editBank.init(expertInfoData, isUpdate)
    },
    /**
     * 修改手机号码
     */
    editPhone (expertInfoData) {
      this.$refs.editMobilePhone.expertId = expertInfoData.id
      this.$refs.editMobilePhone.editMobilePhoneModal = true
    },
    // 专家不同意参加
    onNotAgreeJoin (data) {
      const that = this
      let selectExtractExpertVo = { ...data }
      this.$confirm({
        title: '确认不参加?',
        onOk () {
          selectExtractExpertVo.expertFlag = ExtractExpertFlagEnum.ATTEND[0]
          that.handleSetParticipationStatus(selectExtractExpertVo)
        },
      })
    },
    // 专家同意参加
    onAgreeJoin (data) {
      const that = this
      let selectExtractExpertVo = { ...data }
      this.$confirm({
        title: '确认同意参加?',
        onOk () {
          selectExtractExpertVo.expertFlag = ExtractExpertFlagEnum.BUSY[0]
          that.handleSetParticipationStatus(selectExtractExpertVo)
        },
      })
    },
    /**
     * 确认提交同意参加或不参加状态
     */
    async handleSetParticipationStatus (selectExtractExpertVo) {
      const res = await SetParticipationStatus(selectExtractExpertVo)
      if (res.code == 200) {
        this.$message.success('操作成功')
        this.onLoadReviewActiveNotice()
      } else {
        this.$message.error(res.message)
      }
    },
    //专家请假
    onLeaveApplyFor (record) {
      this.$refs.expertLeaveApplyForModal.init(record)
    },
    goToPreviewHistory () {
      this.$router.push({ path: '/loginExpert/selectApplyIndex' })
    },
    /**
     * 查看审批记录
     * @param record 审批数据
     */
    onViewAuditRecord (record) {
      this.$refs.editExpertPurchaseItem.viewData(record.id, true)
    },
    goToExpertGuide () {
      this.$info({ title: '内容调整中，即将上线。' })
    },
    openLeaveDescription () {
      const content = `采购活动通知同意参加后如果有事需要请假，超过集合时间2小时的，
      可通过我司网站（${this.website ? this.website : ''}）或微信公众号登录专家管理系统进行操作；若离集合时间不足2小时的，
      必须拨打咨询电话${this.consult_telePhone}进行请假。`
      this.$info({ title: '请假说明', content: content })
    }
  },
}
</script>

<style lang="less" scoped>
.cghd_list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    background: #f2f6ff;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 12px;

    .info {
      padding: 0 16px;
      width: 100%;
      padding-bottom: 10px;
      border: 1px solid #e6e6e6;

      .text1 {
        font-size: 18px;
        margin-top: 10px;

        .title {
          font-weight: bold;
        }
      }
    }

    .btn_box {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      div {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
      }

      button {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
        background: #fff;
        border: none;
        border-radius: 100px;
        font-size: 18px;
        padding: 0 20px 0 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-left: 30px;

        i {
          font-size: 32px;
          margin-right: 12px;
        }
      }
    }
  }
}

.card_img {
  position: absolute;
  box-sizing: content-box;
  margin: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  pointer-events: none;
}

.index_t2 {
  background-image: url('../../assets/p7.png');
  background-size: cover;
  margin-top: 16px;

  .item {
    display: flex;
    align-items: center;
    border: 2px solid #fff;
    border-radius: 8px;
    padding: 0 12px;
    position: relative;

    i {
      position: absolute;
      right: 20px;
      font-size: 24px;
      color: #ef9205;
      top: 10px;
      height: 32px;
      bottom: 0;
      margin: auto;
    }

    .img {
      margin-right: 12px;
      flex: 0 0 auto;
      width: 96px;
    }

    div {
      p {
        margin: 0;
        font-size: 16px;
      }

      b {
        color: #6ba3fe;
        font-size: 24px;
      }

      .text2 {
        color: red;
      }

      .text3 {
        font-size: 28px;
        color: #ef9205;
        font-weight: bold;
      }
    }

    &:nth-child(1) {
      margin-bottom: 12px;
    }

    &.v2 {
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
      }
    }
  }
}

.index_t1 {
  .r3 {
    border-top: 1px solid #e6e6e6;
    margin-top: 16px;
    padding-top: 16px;
    text-align: center;

    b {
      color: red;
      font-size: 17px;
    }
  }

  .r2 {
    display: flex;
    margin-top: 16px;

    .img {
      flex: 0 0 auto;

      img {
        width: 100px;
        height: 140px;
      }
    }

    .info {
      padding-left: 16px;

      p {
        margin: 0;
      }

      .text1 {
        font-size: 24px;
        color: #436b94;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
      }

      .text2 {
        display: flex;
        flex-wrap: wrap;

        div {
          width: 50%;
          min-width: 200px;
          margin-bottom: 8px;
        }
      }
    }
  }

  .r1 {
    background: #fff0f0;
    align-items: center;
    padding: 8px 12px;

    .text {
      width: 100%;
    }

    .icon {
      flex: 0 0 auto;
      margin-right: 12px;
      color: #ff8484;
    }

    a {
      flex: 0 0 auto;
      color: #ff8484;
    }
  }
}

/deep/ .card_right_first .ant-card-body {
  min-height: 260px;

  .flex-center {
    min-height: 230px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/deep/ .card_right_two {
  margin-top: 16px;

  .ant-card-body {
    min-height: 190px;
    padding: 0 5px;

    .fx-form-view td {
      padding: 0;
    }

    .flex-center {
      min-height: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}


</style>
